export default "__VITE_ASSET__C6Gu_eoG__"